import Axios from 'axios'
import QS from 'qs'
import {Message} from 'element-ui'

Axios.defaults.timeout = 10000;
Axios.defaults.withCredentials = true;
Axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';



const $http={
    get:function(url, params){
      return new Promise((resolve, reject) => {
        Axios.get(url, {
          params: params,
        }).then(res => {
          resolve(res.data);
        }).catch(err => {
          reject(err.data)
        })
      })
    },
  post:function (url, params) {
    return new Promise((resolve, reject) => {
      Axios.post(url,QS.stringify(params),
      ).then(res => {
        resolve(res.data);
      }).catch(err => {
        reject(err.data)
      })
    })
  },
  all:function (resArrFun) {
    return new Promise((resolve, reject) => {
      Axios.all(resArrFun).then(Axios.spread(function () {
        resolve(arguments);
      })).catch(err => {
        reject(err.data)
      })

    })
  }
}

export {$http};






// WEBPACK FOOTER //
// ./src/request/axiosHttp.js